var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.7915 18.125C8.48186 18.125 9.0415 17.5654 9.0415 16.875C9.0415 16.1846 8.48186 15.625 7.7915 15.625C7.10115 15.625 6.5415 16.1846 6.5415 16.875C6.5415 17.5654 7.10115 18.125 7.7915 18.125Z",
    fill: "#7D5B51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9165 18.125C16.6069 18.125 17.1665 17.5654 17.1665 16.875C17.1665 16.1846 16.6069 15.625 15.9165 15.625C15.2261 15.625 14.6665 16.1846 14.6665 16.875C14.6665 17.5654 15.2261 18.125 15.9165 18.125Z",
    fill: "#7D5B51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.84619 5.625H18.8618L16.7993 12.8437C16.7257 13.1057 16.5681 13.3363 16.3508 13.5C16.1334 13.6638 15.8683 13.7516 15.5962 13.75H8.11182C7.8397 13.7516 7.57459 13.6638 7.35722 13.5C7.13986 13.3363 6.98228 13.1057 6.90869 12.8437L4.08057 2.95313C4.04319 2.82246 3.96425 2.70754 3.8557 2.62578C3.74715 2.54401 3.6149 2.49986 3.479 2.5H2.1665",
    stroke: "#7D5B51",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartFilled);
export default __webpack_public_path__ + "static/media/cart-filled.326d9da4576a45e2de4afe7183711afb.svg";
export { ForwardRef as ReactComponent };